<script>
import { actionTypes, entityTypes } from '../constants';

const actionOptions = [
  { value: actionTypes.login, text: 'Логин' },
  { value: actionTypes.create, text: 'Создание' },
  { value: actionTypes.update, text: 'Редактирование' },
  { value: actionTypes.remove, text: 'Удаление' },
];
const entityOptions = [
  { value: entityTypes.admin, text: 'Администратор' },
  { value: entityTypes.department, text: 'Департамент' },
  { value: entityTypes.log, text: 'Запись лога' },
  { value: entityTypes.project, text: 'Проект' },
  { value: entityTypes.settings, text: 'Настройки' },
  { value: entityTypes.weekends, text: 'Календарь' },
  { value: entityTypes.worker, text: 'Сотрудник' },
];

export default {
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  computed: {
    adminOptions () {
      return Object
        .values(this.$store.state.dict.admins)
        .map(admin => ({
          text: admin.username,
          value: admin.id,
        }));
    },
  },
  methods: {
    emitChange (newValues) {
      this.$emit('change', {
        ...this.value,
        ...newValues,
      });
    },
    handleAdminSelect (adminId) {
      this.emitChange({ adminId });
    },
    handleActionTypeSelect (actionType) {
      this.emitChange({ actionType });
    },
    handleEntityTypeSelect (entityType) {
      this.emitChange({ entityType });
    },
    handleEntityIdChange (e) {
      const entityId = e.target.value;
      this.emitChange({ entityId });
    },
  },
  render () {
    const { $style, value } = this;

    return (
      <div class={$style.wrapper}>
        <div class={$style.input}>
          <u-select
            value={value.adminId}
            options={this.adminOptions}
            placeholder="Пользователь"
            resetText="Все пользователи"
            onInput={this.handleAdminSelect}
          />
        </div>
        <div class={$style.input}>
          <u-select
            value={value.actionType}
            options={actionOptions}
            placeholder="Действие"
            resetText="Все действия"
            onInput={this.handleActionTypeSelect}
          />
        </div>
        <div class={$style.input}>
          <u-select
            value={value.entityType}
            options={entityOptions}
            placeholder="Сущность"
            resetText="Все сущности"
            onInput={this.handleEntityTypeSelect}
          />
        </div>
        <div class={[$style.input, $style.entityId]}>
          <u-input
            value={value.entityId}
            placeholder="ID сущности"
            fullwidth
            onChange={this.handleEntityIdChange}
          />
        </div>
      </div>
    );
  },
};
</script>

<style lang="scss" module>
@import '@/theme/include.scss';

.wrapper {
  align-items: center;
  display: flex;
  margin: 0 -1em;
}

.input {
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0 .5em;

  &.entityId {
    flex-grow: 1;
    flex-shrink: 1;
  }
}
</style>
